/** Normalized keys (lowercase, alphanumeric only) → Set of normalized valid answers. */
export const STAGE3_CATEGORY_ANSWERS = {
  countries: new Set([
    'afghanistan', 'albania', 'algeria', 'argentina', 'australia', 'austria', 'bangladesh',
    'belgium', 'brazil', 'canada', 'chile', 'china', 'colombia', 'croatia', 'cuba', 'denmark',
    'egypt', 'england', 'ethiopia', 'finland', 'france', 'germany', 'ghana', 'greece', 'hungary',
    'iceland', 'india', 'indonesia', 'iran', 'iraq', 'ireland', 'israel', 'italy', 'japan',
    'kenya', 'malaysia', 'mexico', 'morocco', 'nepal', 'netherlands', 'newzealand', 'nigeria',
    'norway', 'pakistan', 'peru', 'philippines', 'poland', 'portugal', 'romania', 'russia',
    'saudiarabia', 'scotland', 'singapore', 'southafrica', 'southkorea', 'spain', 'srilanka',
    'sweden', 'switzerland', 'thailand', 'turkey', 'uae', 'ukraine', 'unitedkingdom',
    'unitedstates', 'usa', 'vietnam', 'wales', 'zimbabwe',
  ]),
  sports: new Set([
    'archery', 'athletics', 'badminton', 'baseball', 'basketball', 'boxing', 'cricket', 'cycling',
    'diving', 'fencing', 'football', 'golf', 'gymnastics', 'handball', 'hockey', 'judo',
    'kabaddi', 'karate', 'lacrosse', 'marathon', 'motorsport', 'netball', 'polo', 'rowing',
    'rugby', 'sailing', 'shooting', 'skateboarding', 'skiing', 'snowboarding', 'soccer',
    'softball', 'squash', 'surfing', 'swimming', 'tabletennis', 'taekwondo', 'tennis',
    'triathlon', 'volleyball', 'weightlifting', 'wrestling',
  ]),
  animals: new Set([
    'ant', 'bear', 'bee', 'bird', 'buffalo', 'camel', 'cat', 'cheetah', 'chicken', 'cow',
    'crocodile', 'deer', 'dog', 'dolphin', 'duck', 'eagle', 'elephant', 'fish', 'fox', 'frog',
    'giraffe', 'goat', 'gorilla', 'hamster', 'horse', 'kangaroo', 'koala', 'lion', 'monkey',
    'mouse', 'octopus', 'owl', 'panda', 'parrot', 'penguin', 'pig', 'rabbit', 'rat', 'rhino',
    'seal', 'shark', 'sheep', 'snake', 'squirrel', 'tiger', 'turtle', 'whale', 'wolf', 'zebra',
  ]),
  movies: new Set([
    'avatar', 'avengers', 'batman', 'blackpanther', 'casablanca', 'dune', 'frozen', 'gladiator',
    'harrypotter', 'inception', 'interstellar', 'jaws', 'joker', 'jurassicpark', 'lionking',
    'matrix', 'moana', 'oppenheimer', 'rocky', 'shrek', 'spiderman', 'starwars', 'superman',
    'titanic', 'toystory', 'up', 'zootopia',
  ]),
  superheroes: new Set([
    'antman', 'aquaman', 'batman', 'blackpanther', 'blackwidow', 'captainamerica', 'captainmarvel',
    'deadpool', 'doctorstrange', 'flash', 'greenlantern', 'hawkeye', 'hulk', 'ironman', 'loki',
    'spiderman', 'superman', 'thor', 'wolverine', 'wonderwoman',
  ]),
  brands: new Set([
    'adidas', 'amazon', 'apple', 'bmw', 'cocacola', 'disney', 'facebook', 'google', 'gucci',
    'honda', 'ikea', 'instagram', 'lego', 'lg', 'mcdonalds', 'mercedes', 'microsoft', 'nike',
    'nintendo', 'pepsi', 'samsung', 'sony', 'starbucks', 'tesla', 'toyota', 'twitter', 'visa',
    'walmart', 'youtube',
  ]),
  vegetables: new Set([
    'asparagus', 'beetroot', 'broccoli', 'cabbage', 'carrot', 'cauliflower', 'celery', 'corn',
    'cucumber', 'eggplant', 'garlic', 'ginger', 'kale', 'lettuce', 'mushroom', 'onion', 'peas',
    'pepper', 'potato', 'pumpkin', 'radish', 'spinach', 'tomato', 'turnip', 'zucchini',
  ]),
  fruits: new Set([
    'apple', 'apricot', 'avocado', 'banana', 'blueberry', 'cherry', 'coconut', 'grape',
    'grapefruit', 'guava', 'kiwi', 'lemon', 'lime', 'lychee', 'mango', 'melon', 'orange',
    'papaya', 'peach', 'pear', 'pineapple', 'plum', 'pomegranate', 'raspberry', 'strawberry',
    'watermelon',
  ]),
  cartooncharacters: new Set([
    'aladdin', 'ariel', 'bart', 'batman', 'ben10', 'bugs', 'bugsbunny', 'buzzlightyear',
    'cinderella', 'daffy', 'daffyduck', 'dora', 'donaldduck', 'elsa', 'flintstones', 'fred',
    'garfield', 'goofy', 'homer', 'jerry', 'lisa', 'marge', 'mario', 'mickey', 'mickeymouse',
    'minnie', 'minniemouse', 'naruto', 'olaf', 'pikachu', 'popeye', 'scooby', 'scoobydoo',
    'shaggy', 'simba', 'sonic', 'spongebob', 'squidward', 'superman', 'tom', 'tweety',
    'velma', 'winnie', 'winniethepooh', 'woody',
  ]),
  musicalinstruments: new Set([
    'accordion', 'banjo', 'bass', 'cello', 'clarinet', 'drums', 'flute', 'guitar', 'harmonica',
    'harp', 'keyboard', 'mandolin', 'oboe', 'organ', 'piano', 'saxophone', 'trombone', 'trumpet',
    'tuba', 'ukulele', 'viola', 'violin', 'xylophone',
  ]),
  thingsyoufindinanoffice: new Set([
    'binder', 'calendar', 'chair', 'clipboard', 'computer', 'desk', 'envelope', 'eraser', 'fax',
    'folder', 'keyboard', 'lamp', 'laptop', 'marker', 'monitor', 'mouse', 'notebook', 'paper',
    'pen', 'pencil', 'phone', 'printer', 'scanner', 'stapler', 'tape', 'whiteboard',
  ]),
  thingsthatfly: new Set([
    'airplane', 'balloon', 'bat', 'bee', 'bird', 'butterfly', 'drone', 'eagle', 'falcon',
    'glider', 'helicopter', 'jet', 'kite', 'mosquito', 'owl', 'parrot', 'pigeon', 'plane',
    'rocket', 'seagull', 'sparrow', 'wasp',
  ]),
  thingsfoundinakitchen: new Set([
    'blender', 'bowl', 'cup', 'fork', 'fridge', 'grater', 'kettle', 'knife', 'ladle', 'microwave',
    'mug', 'oven', 'pan', 'plate', 'pot', 'refrigerator', 'sink', 'spatula', 'spoon', 'stove',
    'toaster', 'whisk',
  ]),
  boardgames: new Set([
    'backgammon', 'battleship', 'candyland', 'checkers', 'chess', 'clue', 'dominoes', 'jenga',
    'life', 'monopoly', 'operation', 'risk', 'scrabble', 'sorry', 'taboo', 'trivialpursuit',
    'twister', 'uno',
  ]),
  mobileapps: new Set([
    'amazon', 'facebook', 'gmail', 'googlemaps', 'instagram', 'linkedin', 'netflix', 'paypal',
    'pinterest', 'reddit', 'snapchat', 'spotify', 'telegram', 'tiktok', 'twitter', 'uber',
    'whatsapp', 'youtube', 'zoom',
  ]),
  festivals: new Set([
    'christmas', 'diwali', 'easter', 'eid', 'halloween', 'hanukkah', 'holi', 'independence',
    'newyear', 'oktoberfest', 'pongal', 'ramadan', 'thanksgiving', 'valentines',
  ]),
  spaceobjects: new Set([
    'asteroid', 'comet', 'earth', 'galaxy', 'jupiter', 'mars', 'mercury', 'meteor', 'moon',
    'neptune', 'planet', 'pluto', 'satellite', 'saturn', 'star', 'sun', 'uranus', 'venus',
  ]),
  seacreatures: new Set([
    'clam', 'crab', 'dolphin', 'fish', 'jellyfish', 'lobster', 'octopus', 'otter', 'seahorse',
    'seal', 'shark', 'shrimp', 'squid', 'starfish', 'turtle', 'whale',
  ]),
  professions: new Set([
    'accountant', 'actor', 'architect', 'artist', 'chef', 'dentist', 'doctor', 'driver', 'engineer',
    'farmer', 'firefighter', 'journalist', 'lawyer', 'mechanic', 'nurse', 'pilot', 'police',
    'scientist', 'teacher', 'writer',
  ]),
};
